import { register } from '../../../../Javascript/Sysmex/Utils'

const Input = el => {
  const prefix = el.dataset.prefix
  const inputEl = el.querySelector('input')
  const clearButton = el.querySelector(`.${prefix}clear`)
  const autoSubmit = el.dataset.autosubmit
  const formElement = inputEl.form

  if (!autoSubmit) return

  let timer

  const changeValue = e => {
    if (e.currentTarget.value.length > 2 || e.currentTarget.value.length === 0) {
      clearTimeout(timer)
      timer = setTimeout(() => {
        // fire submit
        formElement.requestSubmit()
      }, 1600)
    }
  }

  const clearInput = () => {
    inputEl.value = ''
    formElement.requestSubmit()
  }

  inputEl.addEventListener('keyup', changeValue)
  clearButton.addEventListener('click', clearInput)
}
register('Input', Input)
